import { Gem } from 'lucide-react';

import { useTranslation } from '@splitfiesta/i18n';
import { Badge } from '@splitfiesta/ui';

import { cn } from '@/lib/utils';

interface ProPillProps {
  onClick?: () => void;
  size?: 'sm' | 'md';
  /** Hero layouts pass the same overlay classes as the owner/admin badges. */
  className?: string;
}

export function ProPill({ onClick, size = 'sm', className }: ProPillProps) {
  const { t } = useTranslation();

  // Badge drops unknown props, so the test id rides on the wrapper.
  const pill = (
    <Badge variant="warning" size={size} className={cn('shrink-0', className)}>
      <Gem aria-hidden="true" className="h-3 w-3 mr-1" />
      {t('groups:pro.pill')}
    </Badge>
  );

  if (!onClick) {
    return (
      <span data-testid="pro-pill" className="inline-flex shrink-0">
        {pill}
      </span>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={t('groups:pro.pillA11y')}
      data-testid="pro-pill"
      data-pro-focus=""
      className="inline-flex shrink-0 rounded-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-500"
    >
      {pill}
    </button>
  );
}
